export default {
  VIDEO_PLAYER_LOGO: "AdProductVideoPlayerLogo",
  AD_PRODUCT_SPLASH_SCREEN: "AdProductSplashScreen",
  AD_PRODUCT_PARTNER_CONTENT_TAG: "AdProductPartnerContentTag",
  PRE_ROLL_SLATE: "pre_roll_slate",
};
